import styled from 'styled-components';

export const ExpandWrapper = styled.div`
    :hover {
        text-decoration: underline;
    }
`;

export const ExpandedRowWrapperTop = styled.tr`
    & > td { 
        border-top: 1px solid green !important;
    }

    & > td:nth-child(1) { 
        border-left: 1px solid green;
    }

    & > td:nth-last-child(1) { 
        border-right: 1px solid green;
    }
`;

export const ExpandedRowWrapperBottom = styled.tr`
    & > td { 
        border-bottom: 1px solid green;
    }

    & > td:nth-child(1) { 
        border-left: 1px solid green;
    }

    & > td:nth-last-child(1) { 
        border-right: 1px solid green;
    }
`;

export const ExpandedRowWrapper = styled.tr`
    & > td:nth-child(1) { 
        border-left: 1px solid green;
    }

    & > td:nth-last-child(1) { 
        border-right: 1px solid green;
    }
`;